import { render, staticRenderFns } from "./bindCode.vue?vue&type=template&id=65f51c3c"
import script from "./bindCode.vue?vue&type=script&lang=js"
export * from "./bindCode.vue?vue&type=script&lang=js"
import style0 from "./bindCode.vue?vue&type=style&index=0&id=65f51c3c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports